export default {
  index: [
    {
      path: '/eoperation',
      component: resolve => require(['./eoperationIndex.vue'], resolve),
    },
  ]
}



// WEBPACK FOOTER //
// ./src/view/eoperation/_router.js